export const checkEnvVariables = () => {
  const requiredEnvVariables = [
    'REACT_APP_AUTH_CLIENT_ID',
    'REACT_APP_AUTH_DOMAIN',
    'REACT_APP_API_AUTH_AUDIENCE',
    'REACT_APP_AUTH_CALLBACK',
    'REACT_APP_API_URL',
  ];

  const missingEnvVariables = requiredEnvVariables.filter((variable) => !process.env[variable]);

  if (missingEnvVariables.length > 0) {
    throw new Error('Missing required environment variables');
  }
};
